import React, { useState } from 'react';
import './TranslationDialog.css';

export interface LanguageOption {
  value: string;
  label: string;
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { value: 'English', label: 'English' },
  { value: 'French', label: 'French' },
  { value: 'Chinese (Simplified)', label: 'Chinese (Simplified)' },
  { value: 'Vietnamese', label: 'Vietnamese' }
];

interface TranslationDialogProps {
  isOpen: boolean;
  sourceText: string;
  onTranslate: (targetLanguage: string) => Promise<void>;
  onClose: () => void;
  isTranslating?: boolean;
  error?: string | null;
}

const TranslationDialog: React.FC<TranslationDialogProps> = ({
  isOpen,
  sourceText,
  onTranslate,
  onClose,
  isTranslating = false,
  error = null
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>('English');

  if (!isOpen) return null;

  const handleTranslate = async () => {
    if (!selectedLanguage || !sourceText.trim()) {
      return;
    }
    await onTranslate(selectedLanguage);
  };

  const handleClose = () => {
    if (!isTranslating) {
      onClose();
    }
  };

  return (
    <div className="translation-dialog-overlay" onClick={handleClose}>
      <div className="translation-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="translation-dialog-header">
          <h3 className="translation-dialog-title">Translate Block</h3>
          {!isTranslating && (
            <button
              className="translation-dialog-close"
              onClick={handleClose}
              title="Close"
            >
              ✕
            </button>
          )}
        </div>

        <div className="translation-dialog-content">
          <div className="translation-dialog-section">
            <label className="translation-dialog-label">
              Target Language
            </label>
            <select
              className="translation-dialog-select"
              value={selectedLanguage}
              onChange={(e) => setSelectedLanguage(e.target.value)}
              disabled={isTranslating}
            >
              {LANGUAGE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="translation-dialog-section">
            <label className="translation-dialog-label">
              Source Text
            </label>
            <div className="translation-dialog-preview">
              {sourceText || '(empty block)'}
            </div>
          </div>

          {error && (
            <div className="translation-dialog-error">
              {error}
            </div>
          )}

          {isTranslating && (
            <div className="translation-dialog-loading">
              <span className="translation-dialog-loading-text">Translating...</span>
            </div>
          )}
        </div>

        <div className="translation-dialog-actions">
          <button
            className="translation-dialog-btn translation-dialog-btn-cancel"
            onClick={handleClose}
            disabled={isTranslating}
          >
            Cancel
          </button>
          <button
            className="translation-dialog-btn translation-dialog-btn-translate"
            onClick={handleTranslate}
            disabled={isTranslating || !sourceText.trim() || !selectedLanguage}
          >
            {isTranslating ? 'Translating...' : 'Translate'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TranslationDialog;

